import { RouteRecordRaw } from 'vue-router'

const surveyScheduleRoutes: RouteRecordRaw[] = [
  {
    path: '/surveys/schedule',
    name: 'surveys.schedule',
    component: () => import('@/modules/operations/views/Surveys/SurveyScheduleIndex.vue'),
    meta: {
      pageTitle: 'Survey schedule',
      breadcrumbs: ['Survey schedule']
    }
  },
  {
    path: '/surveys/schedule/create',
    name: 'surveys.schedule.create',
    component: () => import('@/modules/operations/views/Surveys/SurveysEdit.vue'),
    meta: {
      pageTitle: 'Schedule Survey',
      breadcrumbs: ['Survey schedule', 'Schedule']
    }
  },
  // Legacy redirect
  {
    path: '/survey-schedule',
    redirect: { name: 'surveys.schedule' }
  }
]

export default surveyScheduleRoutes
